<template>
  <ion-row>
    <ion-col size-md="12" size-lg="12">
      <section>
        <ion-row>
          <ion-col size="2">
            <PersonalizeProgress :current-step="2" :total-steps="4" />
          </ion-col>
          <ion-col size="10">
            <h3 class="h3 text-color-body">{{ t('personalize.datesTitle') }}</h3>
          </ion-col>
        </ion-row>
        <p class="text-color-body text-align-left">{{ t('personalize.datesDescription') }}</p>
        <div class="mt-lg">
          <ion-row>
            <ion-col size="12" class="mt-sm">
              <CustomInput
                :min-date="dayjs().format('YYYY-MM-DD')"
                form-name="personalize"
                type="date"
                :value="personalizeForm.arrival"
                v-model="personalizeForm.arrival"
                input-type="date"
                :label="t('personalize.labels.arrival')"
                name="arrival"
                :placeholder="t('personalize.placeholders.arrival')"
                :clear-field="false"
                @update:modelValue="changeStart()"
              />
            </ion-col>
            <ion-col size="12" class="mt-sm">
              <CustomInput
                form-name="personalize"
                type="date"
                :value="personalizeForm.departure"
                v-model="personalizeForm.departure"
                input-type="date"
                :label="t('personalize.labels.departure')"
                name="departure"
                :placeholder="t('personalize.placeholders.departure')"
                :min-date="personalizeForm.arrival"
                :clear-field="false"
              />
            </ion-col>
          </ion-row>
        </div>
      </section>
    </ion-col>
  </ion-row>
</template>
<script setup lang="ts">
  import { IonCol, IonRow } from '@ionic/vue';
  import { useI18n } from 'vue-i18n';
  import CustomInput from '@/components/shared/form/CustomInput.vue';
  import { usePersonalize } from '@/composables/usePersonalize';
  import PersonalizeProgress from '@/components/personalize/PersonalizeProgress.vue';
  import dayjs from 'dayjs';

  const { t } = useI18n();
  const { personalizeForm } = usePersonalize();

  const changeStart = () => {
    const startDate = dayjs(personalizeForm.value.arrival);
    const endDate = dayjs(personalizeForm.value.departure);

    const isAfter = startDate.isAfter(endDate);

    if (isAfter) {
      personalizeForm.value.departure = undefined;
    }
  };
</script>
<style scoped lang="scss"></style>
